import { gql, useQuery } from '@apollo/client'
import { DeliveryDateInfo } from 'src/types/deliveryDateInfo'

// fetch all queries that depends on delivery date
export const GET_DELIVERY_DAY_INFO_QUERY = gql`
  query deliveryDayInfo($date: String!) {
    deliveryDateStatus(date: $date)
    orderTimeline(date: $date) {
      date
      statusKey
    }
    promotionsByDate(date: $date) {
      promotions {
        origin
        promotionType
        discount {
          type
          rate
        }
        compoundPromotions {
          rate
          type
          orderCount
        }
        compoundPromotionUses {
          deliveryDate
          orderCount
        }
      }
    }
  }
`

export function useGetDeliveryDayInfo(date: string | null | undefined) {
  const { data, ...rest } = useQuery<DeliveryDateInfo>(
    GET_DELIVERY_DAY_INFO_QUERY,
    {
      notifyOnNetworkStatusChange: true,
      fetchPolicy: 'cache-and-network',
      skip: !date,
      variables: {
        date
      }
    }
  )

  return {
    data: data || {
      promotionsByDate: null,
      deliveryDateStatus: '',
      orderTimeline: []
    },
    ...rest
  }
}
